<template>
    <div>
      <v-btn 
          color="primary" 
          slot="activator" 
          icon dark small
          @click="navigate()"
        >
        <v-icon>navigate_before</v-icon>
      </v-btn>

<!--       <v-btn
        color="primary" 
        :loading="loadingExportChats"
        :disabled="loadingExportChats" 
        slot="activator" 
        flat
        @click="copyMessage()"
      >
        Copiez les données csv
        <v-icon color="primary" right>content_copy</v-icon>
      </v-btn> -->
        <div style="padding:8px;">{{csv}}</div>
    </div>
</template>

<script>

export default {
  data () {
    return {
      loadingExportChats: false,
      csv: this.$route.params.csv
    }
  },
  created () {
    // console.log('csv', this.$route.params.csv)
  },
  methods: {
    navigate () {
      this.csv = ''
      this.$router.go(-1)
    }

    // copyMessage (content) {
    //   this.loadingExportChats = true
    //   const textArea = document.createElement('textarea')
    //   textArea.value = content
    //   document.body.appendChild(textArea)
    //   textArea.focus()
    //   textArea.select()

    //   try {
    //     document.execCommand('copy')
    //     this.$store.dispatch('_Notifier/NEW_NOTIF', {
    //       message: this.$t('copied'),
    //       context: 'success'
    //     })
    //     this.loadingExportChats = false
    //   } catch (err) {
    //     this.loadingExportChats = false
    //   }

    //   document.body.removeChild(textArea)
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stats/ViewCSV.vue